import { render, staticRenderFns } from "./EconomicGroup.vue?vue&type=template&id=51228858&scoped=true"
import script from "./EconomicGroup.vue?vue&type=script&lang=js"
export * from "./EconomicGroup.vue?vue&type=script&lang=js"
import style0 from "./EconomicGroup.vue?vue&type=style&index=0&id=51228858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51228858",
  null
  
)

export default component.exports